import { useState } from 'react';
import useUser from 'src/hook/data/useUser';
import { useAudio } from 'src/hook/global/useAudio';
import { AnswerType } from 'src/model/enum/enums';
import { Word } from 'src/model/Word';
import { GetSoundUrl } from 'src/utils/URLUtils';
import styles from './SpellingItem.module.scss';
interface SpellingItemProps {
    text: string;
    isAnswer: boolean;
    index: number;
    onAnswer: (isCorrect: boolean) => void;
    correctWord: Word;
}

const SpellingItem = ({ text, isAnswer, index, onAnswer, correctWord }: SpellingItemProps) => {
    const [isClicked, setIsClicked] = useState(false);
    const letter = String.fromCharCode(97 + index).toUpperCase();
    const { isWordUpUser } = useUser();
    const { playAudio } = useAudio();

    const handleClick = () => {
        playAudio(GetSoundUrl(isAnswer ? AnswerType.CorrectAnswer : AnswerType.IncorrectAnswer));
        setIsClicked(true);
        setTimeout(() => {
            onAnswer(isAnswer);
        }, 200);
        setTimeout(() => {
            setIsClicked(false);
        }, 400);
    };

    const className = `${styles.spellingItem} ${isClicked ? styles.clicked : ''} ${isClicked ? (isAnswer ? styles.correct : styles.incorrect) : ''}`;

    return (
        <div
            className={className}
            onClick={handleClick}
        >
            <span>{letter}</span>
            <span className={styles.spellingText}>{text}{isAnswer && isWordUpUser() ? '..' : ''}</span>
        </div>
    );
};

export default SpellingItem;
